import {Component, ElementRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import PDFJSExpress from '@pdftron/pdfjs-express-viewer';
import {ModalTypes} from '../../models/modal/modal-types';
import {ModalService} from '../../services/modal.service';
import {ModalState} from '../../models/modal/modal-state';
import {File as HouseShareFile} from '../../models/file/file';
import {AccountService} from '../../services/account.service';
import {FileTypes} from '../../models/file/file-types';
import {LazyLoaderService} from "../../services/lazy-loader.service";
import {ModalStates} from "../../models/modal/modal-states";
import {ConfigService} from "../../services/config.service";
import {WindowService} from "../../services/window.service";
import {LoadingState} from "../../models/loading-state";
import {FileService} from "../../services/file.service";
import {IconNames} from "../../models/icon-names";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: 'document-viewer-modal',
    templateUrl: './document-viewer-modal.component.html',
    encapsulation: ViewEncapsulation.None
})

export class DocumentViewerModalComponent {

    @ViewChild('pdfViewer', {static: false}) viewer: ElementRef;

    ModalTypes = ModalTypes;
    callbackSubscriber = new Subject<ModalState<HouseShareFile>>();
    file: HouseShareFile;
    url: string;
    FileTypes = FileTypes;
    loaded: boolean;
    getSignedUrl = new LoadingState();

    constructor(
        private modalService: ModalService,
        private accountService: AccountService,
        private lazyLoaderService: LazyLoaderService,
        private configService: ConfigService,
        private windowService: WindowService,
        private fileService: FileService) {

        this.callbackSubscriber.subscribe(config => {
                if (config.state === ModalStates.OPEN) {
                    this.configureForm(config.data);
                } else {
                    this.file = null;
                }
            });
    }

    closeModal() {
        this.file = null;
        this.url = null;
        this.modalService.closeModal(ModalTypes.DOCUMENT_VIEWER);
        setTimeout(_ => this.loaded = false);
    }

    configureForm(file: HouseShareFile) {
        this.file = file;

        const isBlobUrl = this.file.url.startsWith('blob:');
        if (isBlobUrl) {
            this.url = this.file.url;
            if (this.file.type === FileTypes.DOCUMENT && this.file.extensionType.toLowerCase() === 'pdf') {
                setTimeout(_ => this.loadPdf());
            }
        } else {
            this.fileService.getSignedUrl(file.reference)
                .subscribe(data => {
                    this.url = data.signedUrl;

                    if (this.file.type === FileTypes.DOCUMENT && this.file.extensionType.toLowerCase() === 'pdf') {
                        setTimeout(_ => this.loadPdf());
                    }
                });
        }
    }

    private loadPdf() {
        PDFJSExpress({
            path: './pdfjs-express-viewer',
            initialDoc: this.url,
            enableAnnotations: false,
            licenseKey: this.configService.pdfJsKey
        }, this.viewer.nativeElement)
            .then(instance => {
                instance.UI.setTheme(this.accountService.getCurrentUser()?.darkMode ? 'dark' : 'light');
            });
    }

    async downloadFile() {
        try {
            await this.fileService.downloadFile(this.file);
        } catch (err) {
            console.error(err);
        }
    }

    protected readonly IconNames = IconNames;
}
